const autocompleteModalEquipService = {
  serviceType: 'Tipo de Servicio',
  frequency: 'Periodicidad',
  mandatory: 'El servicio es obligatorio?',
  expirationOnLastDayOfMonth: 'Caducidad a fin de mes',
  allowMassService: 'Permitir crear servicios en massa',
  mandatoryActions: '¿Son obligatorias las acciones para las preguntas con respuesta "No Conforme"?',
  enableSignature: 'Habilitar Firma',
  mandatorySignature: 'Firma Obligatoria',
};

export default autocompleteModalEquipService;
